<template>
    <div class="flex-grow-1">
        <h1 class="text-3xl sm:text-4xl md:text-6xl">{{ area.title }}</h1>

        <div class="text-subtext-color font-heading text-lg leading-spaced w-full mb-24" v-html="area.content"/>
    </div>
</template>

<script setup lang="ts">

import {useIndexStore} from "../../store";

const {area} = useIndexStore();
const {$image} = useNuxtApp();

useMeta({
	title: `Dokumentation und Anleitungen für ${area.title}`,
	description: area.description,
	image: area.image ? $image.format(area.image, {width: 1200, height: 1200}) : undefined
});
</script>
